import { DatePipe } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-view-trace',
  standalone: true,
  imports: [MatIconModule,DatePipe],
  templateUrl: './view-trace.component.html',
  styleUrl: './view-trace.component.scss'
})
export class ViewTraceComponent {
 
  traceDetails:any
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private dialogRef: MatDialogRef<ViewTraceComponent> ) {
    this.traceDetails = data.data;
    console.log('tarcedata:', this.traceDetails);
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
